import type { EmissionEvidenceListItem } from '../../types/emissions';
import { bytesToHumanReadable } from '../../../../utils';

export const DeleteDialogContent = ({ target }: { target: EmissionEvidenceListItem | null }) => {
  if (!target) {
    return null;
  }
  return (
    <div className='tw:space-y-2'>
      <div className='tw:text-sm'>
        Delete <strong>{target.originalName}</strong> ({bytesToHumanReadable(target.fileSize)})?
      </div>
      <div className='tw:text-xs tw:text-ThemeTextLight'>
        Not linked to any activities. This action cannot be undone.
      </div>
    </div>
  );
};

export const deleteDialogTitle = (target: EmissionEvidenceListItem | null): string =>
  target?.originalName ?? '';
